export default "__VITE_ASSET__i1IBzI9$__"